import * as React from 'react';
import { InnovationPriority } from '@shapeable/copper-connect-types';

export const InnovationPrioritiesContext = React.createContext<InnovationPriority[]>([]);
export const InnovationPrioritiesProvider = InnovationPrioritiesContext.Provider;